import { Application } from "../types";
import * as XLSX from "xlsx";

export const exportToExcel = (students: Application[]) => {
  const headers = [
    "Nombre",
    "Matrícula",
    "Emprendimiento",
    "Categoría",
    "Categoría Especifica",
    "Facultad",
    "Logotipo (URL)",
    "Estado"
  ];

  const rows = students.map(app => ({
    Nombre: app.fullName,
    Matrícula: app.studentId,
    Emprendimiento: app.businessName,
    Categoría: app.businessCategory,
    "Categoría Especifica": app.specificCategory,
    Facultad: app.studentFaculty,
    "Logotipo (URL)": app.businessLogo,
    Estado: app.status,
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows, { header: headers });
  const range = XLSX.utils.decode_range(worksheet["!ref"]!);
  worksheet["!autofilter"] = { ref: XLSX.utils.encode_range(range) };

  worksheet["!cols"] = [
    { wch: 25 }, // Nombre
    { wch: 15 }, // Matrícula
    { wch: 25 }, // Emprendimiento
    { wch: 20 }, // Categoría
    { wch: 20 }, // Facultad
    { wch: 40 }, // Logotipo (URL)
    { wch: 15 }, // Estado
  ];

  Object.keys(worksheet).forEach((cell) => {
    if (worksheet[cell] && typeof worksheet[cell] === "object") {
      worksheet[cell].s = { alignment: { wrapText: true } };
    }
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Expositores");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = `feria-emprendedores-${new Date().toISOString().split("T")[0]}.xlsx`;
  a.click();
};